import { MultiStepEditSectionTemplate } from "components/MainSectionTemplate/MultiStepEditSectionTemplate";
import React, { useState } from "react";
import { chooseCalendarTypeSection } from "./steps/chooseCalendarTypeSection";
import { ExternalCalendarFormState, GoogleCalendarFormState, NewExternalCalendarStep } from "./steps/model";
import { externalCalendarConnectSection } from "./steps/externalCalendarConnectSection";
import { externalCalendarConfigureSection } from "./steps/externalCalendarConfigureSection";
import { googleCalendarConnectSection } from "./steps/googleCalendarConnectSection";
import { googleCalendarConfigureSection } from "./steps/googleCalendarConfigureSection";
import { routes } from "utilities/routing/generatedRoutes";

interface ExternalCalendarNewSectionProps {
  peekICalendarUrl: string
  peekGoogleCalendarUrl: string
  connectToGoogleUrl: string
}

export const ExternalCalendarNewSection = (props: ExternalCalendarNewSectionProps) => {
  const [calendarType, setCalendarType] = useState<server.dto.ExternalCalendarTypes>(null);
  const [googleCalendarFormState, setGoogleCalendarFormState] = useState<GoogleCalendarFormState>({
    artist: null,
    googleCalendarId: "",
    name: "",
    eventCount: 0,
  });
  const [externalCalendarFormState, setExternalCalendarFormState] = useState<ExternalCalendarFormState>({
    artist: null,
    iCalendarUrl: "",
    name: "",
    eventCount: 0,
  });

  const submit = () => {
    if (calendarType === "googleCalendar") {
      return window.CoreApi.ExternalCalendar.SubscribeToGoogleCalendar({
        artistId: googleCalendarFormState.artist.artistId,
        googleCalendarId: googleCalendarFormState.googleCalendarId,
        name: googleCalendarFormState.name,
      });
    } else if (calendarType === "iCalendar") {
      return window.CoreApi.ExternalCalendar.SubscribeToICalendarUrl({
        artistId: externalCalendarFormState.artist.artistId,
        iCalendarUrl: externalCalendarFormState.iCalendarUrl,
        name: externalCalendarFormState.name,
      });
    }

    throw new Error("Unknown calendar type");
  }

  return <MultiStepEditSectionTemplate<NewExternalCalendarStep>
    submit={submit}
    onSuccess={(itemId) => {
      window.location.href = routes.externalCalendar_Detail(itemId).absolute
    }}
    sections={{
      chooseCalendarType: chooseCalendarTypeSection(calendarType, setCalendarType),
      googleCalendarConnect: googleCalendarConnectSection(googleCalendarFormState, setGoogleCalendarFormState, props.peekGoogleCalendarUrl, props.connectToGoogleUrl),
      googleCalendarConfigure: googleCalendarConfigureSection(googleCalendarFormState, setGoogleCalendarFormState),
      externalCalendarConnect: externalCalendarConnectSection(externalCalendarFormState, setExternalCalendarFormState, props.peekICalendarUrl),
      externalCalendarConfigure: externalCalendarConfigureSection(externalCalendarFormState, setExternalCalendarFormState),
    }}
    initialSection="chooseCalendarType"
  />
}